import kr from '@/i18n/locales/kr.json'
import en from '@/i18n/locales/en.json'

export default {
  'kr': kr,
  'en': en
}